import { arrayOf, oneOfType, string } from 'prop-types';
import React from 'react';

function wrap(items) {
  return Array.isArray(items) ? items : [items];
}

class Image extends React.Component {
  constructor(props) {
    super(props);

    const [src, ...fallbacks] = wrap(props.src);

    this.state = { src, fallbacks };

    this.handleError = this.handleError.bind(this);
  }

  handleError() {
    const [next, ...fallbacks] = this.state.fallbacks;
    if (next) this.setState({ src: next, fallbacks });
  }

  render() {
    const { alt, ...rest } = this.props;
    const { src } = this.state;

    return <img {...rest} src={src} alt={alt} onError={this.handleError} />;
  }
}

Image.propTypes = {
  src: oneOfType([string, arrayOf(string.isRequired)]).isRequired,
  alt: string,
};

Image.defaultProps = {
  alt: '',
};

export default Image;
